import React, { useEffect, useState } from 'react';
import CompareItem from './CompareItem.js';
import { SELECT_ITEMS_TO_HEADING, CANCEL_BUTTON, COMPARE_LINK } from '@/components/ProductPricing/data/Localization.js';
import useMediaQuery from '../../../../hooks/useMediaQuery.js';
import CalciteChip from '@/components/shared/CalciteChip.js';

export default function SelectItemsView(props) {
	const [maxSelections, setMaxSelections] = useState(null);
	const isMobile = useMediaQuery('(max-width: 480px)');
	const isTablet = useMediaQuery('(min-width: 481px) and (max-width: 1024px)');
	const isDesktop = useMediaQuery('(min-width: 1025px)');

	useEffect(() => {
		setMaxSelections(getMaxSelcNum());
	}, [isDesktop, isMobile, isTablet]);

	const selected = props.compareItems.reduce((acc, cv) => (cv.isSelected ? acc + 1 : acc), 0);
	const maxComparItemsReached = selected >= maxSelections;
	const hasItemsSelected = props.checkForItemsSelected;
	const mobileState = isMobile ? 'display' : 'hidden';

	function handleCancelCompare() {
		props.handleCancelSelectProd();
	}

	function handleCompareAction() {
		props.handleCompareAction();
	}

	function getMaxSelcNum() {
		const MAX_DESKTOP_QTY = 5;
		const MAX_TABLET_QTY = 3;
		const MAX_MOBILE_QTY = 2;
		const MAX_ITEMS_QTY = props.compareItems?.length;

		if (isDesktop) {
			return MAX_ITEMS_QTY < MAX_DESKTOP_QTY ? MAX_ITEMS_QTY : MAX_DESKTOP_QTY;
		} else if (isTablet) {
			return MAX_ITEMS_QTY < MAX_TABLET_QTY ? MAX_ITEMS_QTY : MAX_TABLET_QTY;
		} else if (isMobile) {
			return MAX_ITEMS_QTY < MAX_MOBILE_QTY ? MAX_ITEMS_QTY : MAX_MOBILE_QTY;
		}
	}

	return (
		<section
			id={props.comparisonTableId}
			className="comparison-table comparison-table--select-items-view mobile-selection-table"
			mobile-state={mobileState}>
			<div className="comparison-table__wrapper padding-leader-2 padding-trailer-2 leader-3 trailer-3" aria-selected="true">
				<div className="mobile-nav">
					<div className="mobile-nav-wrapper">
						<ul role="navigation" id="sections">
							<li className="nav-section current active">Sections</li>
						</ul>
						<div className="nav-mobile-arrow"></div>
					</div>
				</div>
				<div className="comparison-table__content">
					<h2 className="comparison-table__content--heading avenir-regular padding-trailer-1">
						<span>{SELECT_ITEMS_TO_HEADING}</span>
						<CalciteChip className="selected-items-chip">
							{selected} / {maxSelections}
						</CalciteChip>
					</h2>
					<div className="comparison-table__content--items">
						{props.compareItems.map((option, indx) => {
							return (
								<CompareItem
									noMoreComparItemsAllowed={maxComparItemsReached}
									key={indx}
									optionInfo={option}
									handleComparisonSelection={props.handleComparisonSelection}
								/>
							);
						})}
					</div>

					<div className="comparison-table__content--cta leader-2">
						<calcite-button onClick={handleCancelCompare} scale="l" color="inverse" kind="inverse" appearance="transparent">
							{CANCEL_BUTTON}
						</calcite-button>
						{hasItemsSelected && (
							<calcite-button onClick={handleCompareAction} scale="l" color="neutral" kind="neutral">
								{COMPARE_LINK}
							</calcite-button>
						)}
					</div>
				</div>
			</div>
		</section>
	);
}
